export default __webpack_public_path__ + "static/media/new-13.51d72e9f.png";